<script lang="ts" setup>
	import { useOnline } from '@vueuse/core'

	const isOnline = useOnline()
</script>

<template>
	<div class="fixed left-0 top-0 w-full" :class="[!isOnline ? 'z-[1000]' : '-z-5 invisible delay-100']">
		<div
			class="custom-transition-2 sticky left-0 top-0 z-[200] flex items-center justify-center overflow-hidden text-base font-semibold tracking-wide text-white"
			:class="[!isOnline ? 'h-8 bg-error-400 p-2' : 'h-0 bg-primary-2']"
		>
			{{ !isOnline ? 'You are currently offline' : 'Welcome Back' }}
		</div>
	</div>
</template>
